import React from "react";
import {dayMonthYearAtTime} from "../../utils/dates";

class NodePingsGrid {
  title = 'Lista de Pings do Node';
  showNewButton = false;
  columns = [
    {
      Header: "Node mac",
      accessor: "nodeMac"
    },
    {
      Header: "Gateway Mac",
      accessor: "gatewayMac"
    },
    {
      Header: "Quando",
      Cell: row => dayMonthYearAtTime(row.original.when)
    },
    {
      Header: "Antenas",
      accessor: "antennas",
      Cell: row => (
          <div>  {(row.original.antennas || []).map(({uuid}) => {
            return <h6 key={uuid}>{uuid}</h6>
          })}
          </div>
      )
    }
  ];
  endpoint = function (props) {
    const id = props.match.params.id;
    return `cloud/v1/nodes/${id}/pings`;
  };

}

export default NodePingsGrid;



// WEBPACK FOOTER //
// ./src/gateways/node/NodePingsGrid.js